import { useLang } from "@/context/LanguageContext";
import { CLASS_FEES, BILLING_ENTITY, GST_RATE, fmtFee } from "@/lib/offer";

export const FeesInfo = ({ dark = false, testid }) => {
  const { L } = useLang();
  const sub = dark ? "text-slate-300" : "text-slate-600";
  return (
    <div className={`rounded-2xl p-5 border ${dark ? "border-white/15 bg-white/5" : "border-slate-200 bg-white"}`} data-testid={testid}>
      <div className={`font-bold ${dark ? "text-white" : "text-[#0A192F]"}`}>{L("Annual fees · classroom + lab assistance", "वार्षिक फ़ीस · क्लासरूम + लैब सहायता")}</div>
      <ul className="mt-2 space-y-1 text-sm">
        {CLASS_FEES.map((f) => <li key={f.fee} className="flex justify-between gap-4" data-testid={`${testid}-fee-${f.fee}`}><span>{L(...f.label)}</span><b>{fmtFee(f.fee)} + {GST_RATE}% GST</b></li>)}
      </ul>
      <p className={`mt-3 text-xs ${sub}`}>{L("Kits not included. New admissions: 50% / 70% coupons on /enroll. Schools: 20–30% off.", "किट शामिल नहीं। नए दाखिले: /enroll पर 50% / 70% कूपन। स्कूल: 20–30% छूट।")}</p>
      <p className={`mt-1 text-xs ${sub}`}>{L("Billed by", "बिलिंग")}: {BILLING_ENTITY}</p>
    </div>
  );
};
